import { React, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import OutsideClickHandler from "react-outside-click-handler";
import { useLocation } from "react-router";

import { LinkButton } from "../../commonComponents/Buttons";
import DropDownMenu from "../../commonComponents/DropDownMenu";

import { useWindowDimensions } from "../../../hooks";

import { get_challenge_info } from "../../../redux/features/challengeSlice";

function ChallengePage() {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useDispatch();
  let location = useLocation();

  const [count, setCount] = useState();

  const [challengeInfo, setChallengeInfo] = useState();
  const [dropDownNav, setDropDownNav] = useState();
  const [activeItemDropDownNav, setActiveItemDropDownNav] = useState();

  useEffect(() => {
    if (!challengeInfo) {
      let args = {
        categoryId: params.categoryId,
        challengeId: params.challengeId,
      };
      dispatch(get_challenge_info(args)).then((result) => {
        setCount({
          url: result?.payload?.video_url,
          title: result?.payload?.title,
          description: result?.payload?.description,
          type: result?.payload?.type,
          categoryId: params.categoryId,
          challengeId: params.challengeId,
          pdf_file: result?.payload?.pdf_file,
          cover_image: result?.payload?.cover_image,
        });
        setChallengeInfo(result?.payload);
      });
    }
  }, [challengeInfo, params, dispatch]);

  useEffect(() => {
    if (width <= 1025) {
      let locationArr = location?.pathname?.split('/');

      if (locationArr[3] === 'video') {
        setActiveItemDropDownNav(t("challenge"));
      } else if (locationArr[3] === 'list') {
        setActiveItemDropDownNav(t("submissions"))
      }
    }
  }, [width, location, t])

  return (
    <main>
      <LinkButton
        label={t("back")}
        iconClassName="hasIcon--chevron-left"
        viewType="backButton"
        goTo={`/challenges-categories/challenges-list/${params.categoryId}`}
      />
      {width <= 1025 && (
        <OutsideClickHandler onOutsideClick={() => setDropDownNav(false)}>
          <section
            onClick={() => setDropDownNav(!dropDownNav)}
            className="asideDropDown"
            title="Video"
            id="asideDropDown"
          >
            <p className="activeItemTxt hasIcon--chevron-down">{activeItemDropDownNav}</p>
            {dropDownNav && (
              <DropDownMenu>
                <ul>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "currentItem" : ""
                      }
                      to={`/challenge/${params.categoryId}/video/${params.challengeId}`}
                    >
                      {t("challenge")}
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={({ isActive }) =>
                        isActive ? "currentItem" : ""
                      }
                      to={`/challenge/${params.categoryId}/list/${params.challengeId}`}
                    >
                      {t("submissions")}
                    </NavLink>
                  </li>
                </ul>
              </DropDownMenu>
            )}
          </section>
        </OutsideClickHandler>
      )}
      <section className="withAside">
        {width > 1025 && (
          <aside>
            <p className="asideTitle">{challengeInfo?.category_title}</p>
            <ul className="navList">
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "currentItem" : "")}
                  to={`/challenge/${params.categoryId}/video/${params.challengeId}`}
                >
                  {t("challenge")}
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={({ isActive }) => (isActive ? "currentItem" : "")}
                  to={`/challenge/${params.categoryId}/list/${params.challengeId}`}
                >
                  {t("submissions")}
                </NavLink>
              </li>
            </ul>
          </aside>
        )}
        <Outlet context={[count, setCount]} />
      </section>
    </main>
  );
}

export default ChallengePage;